import { render, staticRenderFns } from "./UpsertDialog.vue?vue&type=template&id=b11c58e2&scoped=true&"
import script from "./UpsertDialog.vue?vue&type=script&lang=js&"
export * from "./UpsertDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpsertDialog.vue?vue&type=style&index=0&id=b11c58e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11c58e2",
  null
  
)

export default component.exports